export default "__VITE_ASSET__DmWCKzEv__"